module.exports = "0.28.2";



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/autocomplete.js/version.js
// module id = ../../node_modules/autocomplete.js/version.js
// module chunks = 6